export const formatPhoneNumber = (phonenumber: string) => {
  const cleanedPhoneNumber = phonenumber.trim();
  const isFormated = cleanedPhoneNumber.includes(" "); // we assume the phonenumber has been intentionally formatted if it contains a whitespace

  if (isFormated) return cleanedPhoneNumber;

  const onlyDigits = !cleanedPhoneNumber.match(/\D/);

  if (onlyDigits && cleanedPhoneNumber.length === 8)
    return [cleanedPhoneNumber.slice(0, 3), cleanedPhoneNumber.slice(3, 5), cleanedPhoneNumber.slice(5, 8)].join(" ");

  return cleanedPhoneNumber;
};
